var _g, _g2, _g3, _g4, _g5, _path, _g6, _circle, _circle2, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuRobotTrading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1640_38150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.8799,
    y: 8.37109,
    width: 3.14667,
    height: 9.44,
    fill: "url(#paint0_linear_1640_38150)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1640_38150)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.4533,
    cy: 6.79901,
    r: 3.14667,
    fill: "url(#paint1_linear_1640_38150)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1640_38150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 23.3203,
    width: 7.08,
    height: 7.08,
    rx: 1,
    fill: "url(#paint2_linear_1640_38150)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1640_38150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.8267,
    y: 23.3203,
    width: 7.08,
    height: 7.08,
    rx: 1,
    fill: "url(#paint3_linear_1640_38150)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1640_38150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.93311 20.8789C7.93311 17.0129 11.0671 13.8789 14.9331 13.8789H33.9731C37.8391 13.8789 40.9731 17.0129 40.9731 20.8789V34.8389C40.9731 37.6003 38.7345 39.8389 35.9731 39.8389H12.9331C10.1717 39.8389 7.93311 37.6003 7.93311 34.8389V20.8789Z",
    fill: "url(#paint4_linear_1640_38150)",
    fillOpacity: 0.78,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98311 20.8789C7.98311 17.0405 11.0947 13.9289 14.9331 13.9289H33.9731C37.8115 13.9289 40.9231 17.0405 40.9231 20.8789V34.8389C40.9231 37.5727 38.7069 39.7889 35.9731 39.7889H12.9331C10.1993 39.7889 7.98311 37.5727 7.98311 34.8389V20.8789Z",
    stroke: "white",
    strokeWidth: 0.1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1640_38150",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 13,
    width: 34,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.93311 20.8789C7.93311 17.0129 11.0671 13.8789 14.9331 13.8789H33.9731C37.8391 13.8789 40.9731 17.0129 40.9731 20.8789V34.8389C40.9731 37.6003 38.7345 39.8389 35.9731 39.8389H12.9331C10.1717 39.8389 7.93311 37.6003 7.93311 34.8389V20.8789Z",
    fill: "white",
    fillOpacity: 0.66
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1640_38150)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1640_38150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.8799,
    y: 13.8789,
    width: 3.14667,
    height: 4.72,
    fill: "url(#paint5_linear_1640_38150)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_1640_38150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.57324,
    y: 23.3203,
    width: 5.50667,
    height: 7.08,
    rx: 1,
    fill: "url(#paint6_linear_1640_38150)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_1640_38150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.8267,
    y: 23.3203,
    width: 5.50667,
    height: 7.08,
    rx: 1,
    fill: "url(#paint7_linear_1640_38150)"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.85,
    cx: 17.7665,
    cy: 26.8588,
    r: 2.75333,
    fill: "#222BFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.85,
    cx: 31.1401,
    cy: 26.8588,
    r: 2.75333,
    fill: "#222BFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.85,
    x: 21.3066,
    y: 29.6133,
    width: 6.29333,
    height: 1.57333,
    fill: "#222BFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1640_38150",
    x: 19.8799,
    y: 5.37109,
    width: 9.14648,
    height: 15.4414,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.656666 0 0 0 0 0.570833 0 0 0 0 1 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1640_38150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1640_38150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1640_38150",
    x: 18.3066,
    y: 0.652344,
    width: 12.2935,
    height: 12.293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.656666 0 0 0 0 0.570833 0 0 0 0 1 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1640_38150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1640_38150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1640_38150",
    x: 0,
    y: 19.3203,
    width: 15.0801,
    height: 15.0781,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866667 0 0 0 0 0.833333 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1640_38150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1640_38150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1640_38150",
    x: 33.8267,
    y: 19.3203,
    width: 15.0801,
    height: 15.0781,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866667 0 0 0 0 0.833333 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1640_38150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1640_38150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1640_38150",
    x: 4.93311,
    y: 10.8789,
    width: 45.04,
    height: 37.9609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.933333 0 0 0 0 0.933333 0 0 0 0 0.933333 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1640_38150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1640_38150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1640_38150",
    x: 20.8799,
    y: 11.8789,
    width: 7.14648,
    height: 8.71875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1640_38150"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1640_38150",
    x: 3.57324,
    y: 21.3203,
    width: 9.50684,
    height: 11.0781,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1640_38150"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1640_38150",
    x: 35.8267,
    y: 21.3203,
    width: 9.50684,
    height: 11.0781,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1640_38150"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1640_38150",
    x1: 22.8799,
    y1: 13.0911,
    x2: 26.0265,
    y2: 13.0911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E6CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F41FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1640_38150",
    x1: 22.0933,
    y1: 9.15901,
    x2: 27.6,
    y2: 6.40568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A69FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1640_38150",
    x1: 8.32667,
    y1: 23.3203,
    x2: 4.78667,
    y2: 30.4003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4757FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5867FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1640_38150",
    x1: 44.5601,
    y1: 23.5003,
    x2: 38.6133,
    y2: 30.4003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1640_38150",
    x1: 9.55981,
    y1: 15.4989,
    x2: 41.5598,
    y2: 38.9989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9CEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1640_38150",
    x1: 22.8799,
    y1: 16.2389,
    x2: 26.0265,
    y2: 16.2389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A77FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1640_38150",
    x1: 8.93843,
    y1: 23.3203,
    x2: 4.9128,
    y2: 29.5824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4757FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5867FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1640_38150",
    x1: 41.1918,
    y1: 23.3203,
    x2: 37.1662,
    y2: 29.5824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4757FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5867FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuRobotTrading);
export default __webpack_public_path__ + "static/media/menu-robot-trading.0d25b03155f7b5e032735b40f7181817.svg";
export { ForwardRef as ReactComponent };